var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 63,
    viewBox: "0 0 85 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_190_40665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.7 52.2c-7.2 3-20.3 3.9-26.3-10.5C29.4 24.9 41-.5 41-.5l21.7 52.7ZM19.2 45.3 1.8 53l42.6 5.3-25.2-13Z",
    fill: "#004D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.2 28.3-15.5 1.2 4.5 11.6 11-12.8Z",
    fill: "#FF9D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.3 27.9-39 17.4c8.1 17.5 38 22.3 51.5 9.3a22 22 0 0 0 5.6-8C81 35 71.7 22.7 58.3 27.9Z",
    fill: "#218F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2 37.7a5.3 5.3 0 0 1 3.6-6.5 5.4 5.4 0 0 1 6.6 3.8 5.3 5.3 0 0 1-3.7 6.6 5.4 5.4 0 0 1-6.5-3.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6 45.9c-4.7 6.3-15.6 13.6-27.8 4-14-11.2-16.4-39.4-16.4-39.4L58.6 46Z",
    fill: "#006434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3 37.1a3 3 0 1 1 3.8 2.2 3 3 0 0 1-3.8-2.2Z",
    fill: "#262626"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_190_40665"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h85v63H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon_3.42786079ff76df42ca7cf4efc33e65d2.svg";
export { ForwardRef as ReactComponent };